/*eslint-disable*/

import axios from 'axios';
import * as types from './mutationsType';
import * as Constants from '@/utils/constants';
import Notification from '../utils/notice_manager';

// 取得RSA Key
export async function getRSAKey({ commit }) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}users/key`,
      headers: {},
    });
  } catch (e) {
    return e;
  }
}

// eslint-disable-next-line no-unused-vars
export async function login({ commit }, data) {
  try {
    return await axios({
      method: Constants.HTTP_METHODS.POST,
      url: `${Constants.API_URL}users/admin/login`,
      headers: {
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

// eslint-disable-next-line no-unused-vars
export async function fetchUserInfo({ commit },) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: Constants.HTTP_METHODS.GET,
      url: `${Constants.API_URL}users/info`,
      headers: {
        token: `Bearer ${token}`,
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商店資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getStoreList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/list`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存商店資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveStoreInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除商店資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteStoreInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 所有商品資料目錄
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getAllProductList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/menu`,
      headers: {
        token: data.token,
      },
      data
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商品資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getProductList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/admin/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}



/**
 * 儲存商品資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveProductInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/save`,
      headers: {
        token: token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除商品資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteProductInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/delete`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 訂單資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getOrderList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 賞品盒資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getNotShippedList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/admin/shipping/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 建立出貨單
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function createShippingInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/create/shippingInfo`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 更新訂單資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function updateOrderInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/update`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 更新運送狀態
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function updateOrderStatus({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/update/status`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 更新付款狀態
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function updateOrderPaymentStatus({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/update/payment/status`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 更新運送狀態
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function createShippingOrder({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}shipping/info/create?orderId=${data.orderId}`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

export async function sendShippingOrder({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: data.api,
      headers: {
      },
      data: data.info
    });
  } catch (e) {
    return e;
  }
}


/**
 * 會員資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getUserList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 會員訂單資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getUserOrderList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/order/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 會員資料更新
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveUserInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/admin/save`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 最新消息
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getNewsList({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}news/list?pageIndex=${data.pageIndex}&limit=${data.limit}&t=${new Date().getTime()}`,
    });
  } catch (e) {
    return e;
  }
}

export async function getNewsInfo({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}news/info?id=${data.id}&t=${new Date().getTime()}`,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存最新消息資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveNewsInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}news/save`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除最新消息資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteNewsInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/news/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 首頁
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getHomeList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}banners/admin/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存最新消息資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveHomeInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}banners/admin/save`,
      headers: {
        token: token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除首頁資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteHomeInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}banners/admin/delete`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getProductInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}product/info?productId=${data.productId}`,
      headers: {
        token: token,
      },
    });
  } catch (e) {
    return e;
  }
}

export async function getAdminProductInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}product/admin/info?productId=${data.productId}`,
      headers: {
        token: token,
      },
    });
  } catch (e) {
    return e;
  }
}

export async function getProductTickets({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}product/info/tickets?productId=${data.productId}`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

export async function createProductTickets({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/create/tickets`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 編輯獎品
 * @param commit
 * @param data Object
 * */
export async function saveProductPrize({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/prize/save`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存發票紀錄
 * @param commit
 * @param data Object
 * */
export async function saveInvoiceLog({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}invoice/save/log`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getInvoiceList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}invoice/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 複製商品
 * @param commit
 * @param data Object
 * */
export async function copyProductInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/copy`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function copyAllProductInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/copyAll`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 品牌故事
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getAboutInfo({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}/about/info`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存品牌故事
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveAboutInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/about/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商店設定
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getVendorInfo({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}vendor/info?vendorId=${data.vendorId}`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存商店設定
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveVendorInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}vendor/save`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 後台抽獎
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveAdminLotteryInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/admin/exchange/prize`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 促銷網頁列表
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getSalePageList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}coupon/admin/list`,
      headers: {
        token: token,
      },
      data
    });
  } catch (e) {
    return e;
  }
}



/**
 * 促銷網頁內容
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getSaleInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/sale/info`,
      headers: {
      },
      data
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存促銷網頁內容
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveSaleInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}coupon/save`,
      headers: {
        token: token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 刪除促銷網頁內容
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteSaleInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}coupon/delete`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 商品分類
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getTypeList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}products/type/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 儲存商品分類
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveTypeList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}products/type/add`,
      headers: {
        token: token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 刪除商品主分類
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function removeTypeInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}products/remove/type/`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 刪除商品子分類
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function removeSubTypeInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}products/remove/subtype/`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}


// 上傳檔案 API
export function uploadFile({ commit }, data) {
  return new Promise((resolve, reject) => {
    const api = `${Constants.API_URL}products/image/upload`;
    axios.post(api, data.fileList, {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        token: `Bearer ${data.token}`,
      },
      transformRequest: [function (data) {
        return data;
      }],
      onUploadProgress(e) {
        const percentage = Math.round((e.loaded * 100) / e.total) || 0;
        if (percentage < 100) {
          console.log(`${percentage}%`); // 上传进度
          Notification.notifyObservers('fileProgress', percentage);
        }
      },
    }).then((response) => {
      console.log(response); // {code: 200, description: "", detail: null}
      resolve(response);
    }).catch((error) => {
      console.log(`uploadFile err ${JSON.stringify(error)}`);
      reject(error);
    });
  });
}


/**
 * 商品圖片
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getProductImageList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}products/image/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 刪除商品圖片
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function removeProductImage({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}products/image/delete`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 刪除商品規格
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function removeProductSpec({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/delete/category`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}



/**
 * AFTEE 訂單確認
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function afteeConfirm({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}aftee/payment/confirm`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * AFTEE 取消訂單
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function afteeCancel({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}aftee/payment/cancel`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * AFTEE 訂單明細
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function afteeDetail({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}aftee/payment/detail`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getOrderReport({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/report`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getSellReport({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/sellReport`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function saveProductReturnBonus({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/returnBonus/save`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function saveProductLevelPrice({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/levelPrice/save`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getUserPrizeList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/prize/list`,
      headers: {
        token: token,
      },
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getPaymentList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}payment/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function savePaymentInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}payment/update/status`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getProductWinnerInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/winner/info`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getProductTicketPrizeList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/admin/tickets`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function sendPrizeListToUser({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/admin/send/prize`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}
export async function getVendorList({ commit }) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}users/admin/vendor/list`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

export async function loadUserInfo({ commit }) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}users/info`,
      headers: {
        token: token,
      },
    });
  } catch (e) {
    return e;
  }
}

export async function loadCoinsList({ commit }) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}product/coins?mode=all`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

export async function createATMOrder({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}newebpay/atm/create`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getVendorReportList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}report/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function getVendorFreeReportList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}report/free/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function updateProductPriority({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/priority/save`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

export async function loadProductRecycleList({ commit }, data) {

  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
        url: `${Constants.API_URL}product/admin/recycle/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}
/**
 * 取得標籤列表
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getTagList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}tag/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存標籤資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveTagInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}tag/save`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除標籤資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteTagInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'delete',
      url: `${Constants.API_URL}tag/delete`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 取得贈送紀錄列表
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getUserGiftList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/send/log/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存贈送資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveUserGift({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/send/gift`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 上傳檔案 v2
 */
export function uploadFileV2({ commit }, data) {
  return new Promise((resolve, reject) => {
    const api = `${Constants.API_URL}products/image/upload/v2`;
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    axios.post(api, data, {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        token: `Bearer ${token}`,
      },
      transformRequest: [function (data) {
        return data;
      }],
      onUploadProgress(e) {
        const percentage = Math.round((e.loaded * 100) / e.total) || 0;
        if (percentage < 100) {
          console.log(`${percentage}%`); // 上传进度
          Notification.notifyObservers('fileProgress', percentage);
        }
      },
    }).then((response) => {
      console.log(response); // {code: 200, description: "", detail: null}
      resolve(response);
    }).catch((error) => {
      console.log(`uploadFile err ${JSON.stringify(error)}`);
      reject(error);
    });
  });
}


/**
 * 儲存會員資料
 * @param commit
 * @param data Object
 * */
export function configUserInfo({ commit }, data) {
  console.log(`configUserInfo === ${JSON.stringify(data)}`);
  localStorage.setItem(Constants.TOKEN_KEY, data.token);
  localStorage.setItem(types.SET_USER_INFO, JSON.stringify(data));
  commit(types.SET_USER_INFO, data);
}

export function getCacheUserInfo() {
  const find = localStorage.getItem(types.SET_USER_INFO);
  // console.log(`getCacheUserInfo === ${find}`);
  if (find){
    const user = JSON.parse(find);
    // console.log(`getCacheUserInfo user === `, user);
    return user;
  }
  return null;
}

/**
 * 取得付款資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getPaymentSetting({ commit }) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}payment/settings`,
      headers: {
        token: token,
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存付款資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function savePaymentSetting({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}payment/settings/save`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 取得即時抽況
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getInstantDraw({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post', // 將請求方法改為 POST
      url: `${Constants.API_URL}product/admin/monitor/list`,
      headers: {
        token: token,
      },
      data, // 將 data 作為請求的主體發送
    });
  } catch (e) {
    return e;
  }
}

/**
 * 取得商品 近期瀏覽
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getProductRecentView({ commit }, productId) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'get',
        url: `${Constants.API_URL}product/queue/list?productId=${productId}`,
      headers: {
        token: token,
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商品設定 > 儲存 Boss 設定
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveBossInfo({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/boss/save`,
      headers: {
        token: token,
      },
      data: data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商品設定 > 取得 Boss 列表
 */
// eslint-disable-next-line no-unused-vars
export async function getBossList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}product/boss/list`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 自取取貨通知
 */
// eslint-disable-next-line no-unused-vars
export async function completePickupOrder({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/prepare/complete`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 訂單管理 > 姓名確認通知
 */
// eslint-disable-next-line no-unused-vars
export async function confirmNotify({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}order/confirm/notify`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 會員管理 > 更新體積
 */
// eslint-disable-next-line no-unused-vars
export async function saveUserPrizeWeight({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}users/prize/weight/save`,
      headers: {
        token: token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 會員管理 >消費紀錄
 */
// eslint-disable-next-line no-unused-vars
export async function getUserPrizeLogList({ commit }, data) {
  try {
    const token = localStorage.getItem(Constants.TOKEN_KEY);
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}users/prize/log/list?pageIndex=${data.pageIndex}&limit=${data.limit}&startDate=${data.startDate}&endDate=${data.endDate}&userId=${data.userId}&vendorName=${data.vendorName}`,
      headers: {
        token: token,
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 登出
 * @param commit
 * */
export function logout({ commit }) {
  commit(types.SET_USER_INFO, null);
  localStorage.removeItem(Constants.TOKEN_KEY);
  localStorage.removeItem(types.SET_USER_INFO);
}

